<template>
  <div class="wrappProfile">
      <div class="holdContent">
          <profileData 
          v-if="profileInfo.usr_name !== '' "
           :profileInfo="profileInfo" 
           @changedata='changeData' 
           @changemsg = "msgerr=''"
           :msgerr='msgerr' 
           />
      </div>
  </div>
</template>

<script>
import profileData from '@/components/profileComponents/profileData'
import { mapGetters } from 'vuex'
import { api } from '@/api'
// import { sha256 } from 'js-sha256'

export default {
    name: 'profile',
    components: {
        profileData
    },
    created() {
        this.getUserData()
    },
    data () {
        return{
            profileInfo: {
                usr_name: '',
                usr_active: 0,
                usr_email:'',
                usr_password: '',
                usr_newPassword: '',
                usr_retypePassword: '',
                image: null
            },
            msgerr:''
        }
    },
    methods:{
        changeData (e) {
            let params = new FormData()
            params.append( 'sid' , localStorage.getItem('sid'))

            for (var variable in e) {
                if(variable === 'usr_password') continue
                if(e[variable]!==''&& e[variable]!== this.profileInfo[variable]){
                    if(variable === 'usr_newPassword'){
                        params.append('new_password', e[variable])
                        params.append('current_password', e['old_password'])
                    }else if (variable === 'image')
                        continue
                    else if (variable === 'usr_name') 
                        params.append('name', e[variable])
                    else
                        params.append(variable, e[variable])
                }
            }
            
            api.editUserData(params, this.profileInfo.usr_id).then(() => {  
                // this.$store.commit('setuserData', res.data.data)
                this.msgerr='msg.successfullyChanged'
                this.getUserData()
            }).catch(e => {
                this.msgerr='msg.editingFailed'
                console.log(e)
            })

        },
        getUserData() {
            let params = {
                sid : localStorage.getItem('sid'),
                id : localStorage.getItem('usr_id')
            }
            api.getUserData(params).then(res => {
                this.profileInfo = res.data.data
                this.$store.commit('setuserData', res.data.data)
            }).catch(e => {
             console.log(e)
            })
        },
        setData (getuserData) {
            //  this.profileInfo = getuserData
                for (let property in this.profileInfo) {
                    if(Object.hasOwnProperty.call(getuserData, property))
                        this.profileInfo[property]=getuserData[property]
                }
        },
    },
    watch: {
        // getuserData: {
        //     handler(newVal){
        //         // console.log('newVal')
        //         // console.log(newVal)
        //         this.setData(newVal)
        //     },
        //     deep:true
        // }
    },
    computed: {
    ...mapGetters(['getLoged', 'getuserData'])
    }

}
</script>

<style lang="scss" scoped>
.wrappProfile{
    z-index:1000;
    height: calc(100vh - 180px);
    width:100% !important;
    box-sizing: border-box;
    background-color: var(--main-background-color);
    display:flex;
    margin: 0 auto;
    padding-top: 87px;
     .holdContent {
        box-sizing: border-box;
        padding: 0 30px;
        max-width: 1275px;
        width:1275px;
        margin: 0 auto;
        // min-height: 588px;
       
     }
}
 @media only screen and (max-width: 1305px){
     .wrappProfile{

         width:100%;
         display: flex;
         .holdContent{
            display: flex;
            width:100%;
            display: flex;
         }
     }
 }

// @media only screen and (max-width: 900px){
//      .wrappProfile{
//             //  flex-direction: column;
//             //  align-items: flex-start;
//             // height: 120px;
//             //  padding:22px 35px;
//           .holdContent{
//             box-sizing:border-box;
//             height: 120px;
//             padding:22px 15px;
//             padding: 0 10px;
//         }
//      }
// }
@media only screen and (max-width: 767px){
     .wrappProfile{
         height: initial ;
         padding-top: 47px;
        .holdContent{
            padding:0px 35px;
           
            height:initial;
        }
    }
}
@media only screen and (max-width: 750px){
     .wrappProfile{
         height: initial ;
        //  padding-top: 72px;
        .holdContent{
            padding:0px 16px;
            height:initial;
            width: 100%;
            box-sizing: border-box;
        }
    }
}

</style>